import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github } from "lucide-react";
import logo from "@/assets/logo.png";

export const Footer = () => {
  const links = {
    "For Talent": [
      { label: "Find Challenges", href: "/challenges" },
      { label: "How It Works", href: "/how-it-works" },
      { label: "Community", href: "/community" },
      { label: "Success Stories", href: "/success-stories" },
    ],
    "For Companies": [
      { label: "Post a Challenge", href: "/challenges" },
      { label: "Pricing", href: "/pricing" },
      { label: "Enterprise", href: "/enterprise" },
      { label: "Testimonials", href: "/testimonials" },
    ],
    "Resources": [
      { label: "Help Center", href: "/help" },
      { label: "FAQ", href: "/faq" },
      { label: "Blog", href: "/blog" },
      { label: "Contact", href: "/contact" },
    ],
    "Company": [
      { label: "About", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
    ],
  };

  return (
    <footer className="border-t border-border bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 sm:gap-8">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 md:col-span-1 mb-4 md:mb-0">
            <Link to="/" className="flex items-center gap-2 mb-3 sm:mb-4">
              <img src={logo} alt="Comp3t3 Logo" className="w-14 h-14 sm:w-12 sm:h-12 object-contain" />
              <span className="text-lg sm:text-xl font-bold text-foreground">Comp3t3</span>
            </Link>
            <p className="text-xs sm:text-sm text-muted-foreground mb-3 sm:mb-4 max-w-xs">
              Get hired by proving your skills. No resumes, just results.
            </p>
            <div className="flex gap-2 sm:gap-3">
              {[
                { Icon: Twitter, label: "Follow us on Twitter" },
                { Icon: Linkedin, label: "Connect on LinkedIn" },
                { Icon: Github, label: "View our GitHub" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-8 sm:w-9 h-8 sm:h-9 rounded-lg bg-secondary flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-colors"
                >
                  <Icon className="w-3.5 sm:w-4 h-3.5 sm:h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <p className="font-semibold text-foreground mb-2 sm:mb-3 text-xs sm:text-sm">{category}</p>
              <ul className="space-y-0.5 sm:space-y-1">
                {items.map((item) => (
                  <li key={item.label}>
                    {item.href.startsWith("/") ? (
                      <Link
                        to={item.href}
                        className="block py-1.5 sm:py-2 text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a
                        href={item.href}
                        className="block py-1.5 sm:py-2 text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="border-t border-border mt-6 sm:mt-10 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm text-muted-foreground text-center sm:text-left">
            © {new Date().getFullYear()} Comp3t3. All rights reserved.
          </p>
          <p className="text-xs sm:text-sm text-muted-foreground text-center sm:text-right">
            Made for people who prove it.
          </p>
        </div>
      </div>
    </footer>
  );
};
